export enum PhysicalStoreType {
  STORE_LOCATOR = 'store-locator',
  CLICK_AND_COLLECT = 'click-and-collect',
  SHIP_FROM_STORE = 'ship-from-store',
}

export enum DistributionChannel {
  RAY_BAN = 'Ray-Ban',
  SGH = 'SGH',
  LENS_CRAFTERS = 'LensCrafters',
  UPS = 'UPS',
}

export enum SfsDeliveryOptionType {
  SAME_DAY_DELIVERY = 'sameDayDelivery',
  NEXT_DAY_DELIVERY = 'nextDayDelivery',
}

/* TODO: rename this enum to StoreBrand and detach from EU context */
export enum StoreBrandEU {
  LENS_CRAFTERS = 'LensCrafters',
  OTHER = 'Other',
  RAY_BAN = 'Ray-Ban',
  SUNGLASS_HUT = 'SunglassHut',
  UPS = 'UPS',
}
